export default __webpack_public_path__ + "static/media/schema-ciliaris.cfaf3f21.png";